import React from 'react'
import styleMarker from './Marker.module.scss'

export const MarkerView = (props: { color?: string, size?: number, style?: object }): JSX.Element => {
  const {
    color,
    size,
    style
  } = props

  return (
    <div
      className={styleMarker._}
      style={{
        ...style,
        backgroundColor: color,
        height: size,
        width: size
      }}
    />
  )
}
